import { render, staticRenderFns } from "./GalleryBig5.vue?vue&type=template&id=241d890c&scoped=true&"
import script from "./GalleryBig5.vue?vue&type=script&lang=js&"
export * from "./GalleryBig5.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig5.vue?vue&type=style&index=0&id=241d890c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d890c",
  null
  
)

export default component.exports